import './INF.css';
import React from "react";
import newsArticles from './assets/newsArticles.js'
import mediaHeader from './assets/mediaHeader.svg'

function Carousel(props) {
    return (
        <div>
            <img className="mediaHeader" src={mediaHeader} alt="As seen in"></img>
            <div class="scrollableContainerCounty">
                {newsArticles.map((item, index) => (
                    <div className="cardCounty"  onClick={() => window.open(item.link, '_blank')}>
                        <p className="cardText">"{item.quote}"</p>
                        <p className="cardText">-{item.source}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Carousel;